module.exports = __webpack_public_path__ + "static/media/8_Alex Tsang (fellowship)-min.d9d0f84c.jpeg";